import { cn } from '@shared/utils';
import { Contacts } from './widgets';
import Icon24 from '@assets/icons/24.svg';
import bgImg from '@assets/images/bg.jpg';

export const ContactUs = () => {
  return (
    <div className={cn('page-animation', 'pt-8')}>
      <div className='mx-auto my-0 w-full max-w-[1294px] px-5'>
        <div className='mb-5'>
          <div className={cn('relative mx-2 text-xl font-bold text-[#f2f2f2] uppercase', 'not-md:text-base')}>
            <span className='absolute top-0 -left-3 font-semibold text-[#a73f33]'>/</span>
            Contact Us
          </div>
        </div>
        <div
          className={cn('flex h-[336px] flex-col items-center justify-center gap-4 rounded bg-cover bg-center bg-no-repeat', 'not-md:h-[273px]')}
          style={{ backgroundImage: `url(${bgImg})` }}
        >
          <Icon24 className='mx-auto mt-6 h-[68px] w-[67px] select-none' />
          <Contacts />
        </div>
      </div>
    </div>
  );
};
